import React, { useState } from 'react'
import AdminNavigation from '../../admin/components/AdminNavigation'
import Input from '../components/FormElements/Input'
import { VALIDATOR_REQUIRE } from '../util/validators'
import { useForm } from '../hooks/form-hook'
import './VenueForm.css'
import Button from '../components/UIElements/Button'
import ErrorModal from '../components/UIElements/ErrorModal'
import LoadingSpinner from '../components/UIElements/LoadingSpinner'
import { useNavigate } from 'react-router-dom'

const NewDropdownTournamentForm = () => {
	const [isLoading, setIsLoading] = useState(false)
	const [error, setError] = useState()

	const [formState, inputHandler] = useForm(
		{
			tournamentName: {
				value: '',
				isValid: false,
			},
			tournamentLink: {
				value: '',
				isValid: false,
			},
		},
		false,
	)

	let navigate = useNavigate()

	const dtSubmitHandler = async (event) => {
		event.preventDefault()
		console.log(formState.inputs) // send this to the backend later

		try {
			setIsLoading(true)
			//console.log(process.env.REACT_APP_BACKEND_URL + '/admin/venue/new')
			const response = await fetch(
				process.env.REACT_APP_BACKEND_URL + '/admin/dropdown/new',
				{
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify({
						tournamentName: formState.inputs.tournamentName.value,
						tournamentLink: formState.inputs.tournamentLink.value,
					}),
				},
			)
			const responseData = await response.json()
			if (!response.ok) {
				throw new Error(responseData.message)
			}
			console.log(responseData)
			setIsLoading(false)
			navigate('/admin/dropdown')
		} catch (err) {
			console.log(err)
			setIsLoading(false)
			setError(
				err.message || 'Something went wrong with creating a new tournament.',
			)
		}
		//navigate('/admin/leagues/current')
	}

	const errorHandler = () => {
		setError(null)
	}

	return (
		<React.Fragment>
			<ErrorModal error={error} onClear={errorHandler} />
			<div>
				{isLoading && <LoadingSpinner asOverlay />}
				<AdminNavigation />
				<main>
					<h2>Add a new Tournament to the Dropdown</h2>
					<form className='venue-form' onSubmit={dtSubmitHandler}>
						<Input
							id='tournamentName'
							element='input'
							type='text'
							label='Enter Tournament Name'
							validators={[VALIDATOR_REQUIRE()]}
							errorText='Please enter a valid name'
							onInput={inputHandler}
						/>
						<Input
							id='tournamentLink'
							element='input'
							type='text'
							label='Link'
							validators={[VALIDATOR_REQUIRE()]}
							errorText='Please enter a valid url'
							onInput={inputHandler}
						/>
						<Button type='submit' disabled={!formState.isValid}>
							ADD DROPDOWN TOURNAMENT
						</Button>
					</form>
				</main>
			</div>
		</React.Fragment>
	)
}

export default NewDropdownTournamentForm
